import React, { useContext, useState } from "react";
import { Button } from "../../../../controls";
import SelectCustomer from "../Cart/SelectCustomer";
import { Divider } from "@mui/material";
import CheckoutCustomer from "./CheckoutCustomer/CheckoutCustomer";
import { action, API, controller } from "../../../../api/api";
import { ToFormData } from "../../../../hooks/Method";
import { CartContext } from "../POS";

const GiveChangePopup = ({
  handlePrintReceipt,
  setShowAlert,
  receiptData,
  setReceiptData,
}) => {
  const { cartData } = useContext(CartContext);
  const [customerId, setCustomerId] = useState();
  const [loading, setLoading] = useState(false);

  const handleComplete = () => {
    setLoading(true);
    if (customerId) {
      API(controller.Sell + action.AttachCustomer).post(
        ToFormData({ customerId, sellId: receiptData.id }),
        (res) => {
          if (res.status === 200) {
            res.result &&
              setReceiptData((j) => ({ ...j, customer: res.result }));
            handlePrintReceipt();
          } else handlePrintReceipt();
        }
      );
    } else handlePrintReceipt();

    setLoading(false);
    setShowAlert(false);
  };

  return (
    <div className="flex flex-col gap-6 p-4 w-full">
      <div className="flex flex-col items-center justify-center md:min-w-[380px] mt-7">
        <div>
          <span className="text-[18px] font-semibold text-gray-600 uppercase">
            Give change
          </span>
          <span className="block text-4xl font-bold text-primary my-1">
            ${receiptData.change}
          </span>
        </div>
      </div>

      {cartData.customerId ? (
        <CheckoutCustomer disableDelete={true} />
      ) : (
        <>
          <SelectCustomer
            {...{
              size: "large",
              placeholder: "Add customer to this sale",
              setCustomerId,
            }}
          />
        </>
      )}

      <Divider />
      <Button loading={loading} onClick={handleComplete} size="large" fullWidth>
        Complete Sale
      </Button>
    </div>
  );
};

export default GiveChangePopup;
